import Logo from "../assets/logitech/logitechg.svg";
import LogoSmall from "../assets/logitech/logitech-g-sm.svg";

export const Logitech_brandVariables = {
  siteTitle: "Logitech G",
  siteIcon: "",
  name: "Logitech G",
  name_small: "Logitech",
  logos: {
    large: Logo,
    white: Logo,
    small: Logo,
    medium: Logo,
    alt_text: "Logitech logo",
    profile: LogoSmall,
  },
  brandTheme: "logitech", // Theme of the brand
  site: "", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "NO", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "eng",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "LOGITECH", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: false,
  subClientsForOverviews: null, // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: true,
  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    quickSignUp: false,
    messages: false,
    teams: false,
    news: false,
    challenges: true,
    singleChallenge: true,
    gathers: false,
    preferences: false,
    friends: false,
    zones: false,
    feed: false,
    winners: false,
    qrSignUp: true,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: true,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: false,
    google: false,
    discord: false,
    twitch: false,
  },
  layout: {
    challenge: "event",
  },
  event: {
    forcedCredentialPopup: "",
    eventCode: "logitech_spillexpo_2024", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: true,
    spacecoins_redirect: false,
  },
};
